import { map } from 'lodash';
import { DocType } from '../global/Doc.enum';
import { IconType } from '../global/Icon.enum';
import Root from '../Root';
import type { IChecklist } from './Checklist.interface';
import ChecklistItem from './ChecklistItem';

export default class Checklist extends Root implements IChecklist {
  name: string;
  description: string;
  icon: IconType;
  items: Array<ChecklistItem>;

  getName() {
    return this.name;
  }

  getDescription() {
    return this.description;
  }

  static build = (data: IChecklist) => new Checklist(data);
  static blank = () => new Checklist({ isActive: true });

  /**
   * Constructor
   * @param {IChecklist} data
   */
  constructor(data?: IChecklist) {
    super(DocType.of('__definition.checklist'), data);

    this.name = data?.name || '';
    this.description = data?.description || '';
    // TODO: data?.icon?.id is legacy data structure
    this.icon = IconType.of(data?.icon?.name || data?.icon?.id);
    // TODO: data?.icon?.id is legacy data structure
    this.items = map(data?.items, (obj) => new ChecklistItem(obj));
  }
}
